import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {EquipmentCardEnums, EquipmentCardInterfaces, EquipmentEnums} from '@namespaces/equipment.namespace';
import {CalibrationLabelPipe} from '@pipes/calibration-label/calibration-label.pipe';
import VerificationStatus = EquipmentEnums.VerificationStatus;

@Component({
    selector: 'app-equipment-calibration-date',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ng-container *ngIf="message">
            <span [class]="cssClass">{{message}}</span>&nbsp;<lib-icon *ngIf="popoverMessage"
                   type="help" class="info" style="margin-bottom: -2px" [size]="14"
                      appPopoverMessage
                      [appPopoverMessage]="popoverMessage"
                      [position]="popoverPosition">
            </lib-icon>
        </ng-container>
    `,
    styles: [`
        :host {
            position: relative;
            z-index: 1;
        }
    `]
})

export class CalibrationDateComponent implements OnChanges {
    @Input() calibration: EquipmentCardInterfaces.Card.LastCalibration;
    @Input() calibrationStatus: EquipmentEnums.VerificationStatus;

    public popoverPosition = 'top';

    public statuses = EquipmentCardEnums.CalibrationExpiredStatus;

    public message = '';
    public popoverMessage = '';
    public cssClass = '';

    constructor(
        private calibrationLabelPipe: CalibrationLabelPipe,
    ) {

    }

    ngOnChanges() {
        this.cssClass = '';
        this.message = '';
        this.popoverMessage = '';

        if (this.calibration) {
            /**
             * Для просроченной поверки будет класс с ошибкой, а для скорого окончания - предупреждающий
             * @type {string}
             */
            this.cssClass =
                (
                    this.calibration.status === EquipmentCardEnums.CalibrationExpiredStatus.expired ||
                    this.calibration.status === EquipmentCardEnums.CalibrationExpiredStatus.close
                ) ? 'text-danger' : (this.calibration.status === EquipmentCardEnums.CalibrationExpiredStatus.soon) ? 'text-warning' : '';

            /**
             * Если просрочена, то еще и зачеркнут будет текст
             */
            if (this.calibration.status === EquipmentCardEnums.CalibrationExpiredStatus.expired) {
                this.cssClass += ' line-through';
            }

            switch (this.calibration.status) {
                case EquipmentCardEnums.CalibrationExpiredStatus.expired : {
                    this.popoverMessage = `
                        ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'Поверка', 'Калибровка')}
                        просрочена`;
                    break;
                }
                case EquipmentCardEnums.CalibrationExpiredStatus.close : {
                    this.popoverMessage = `
                        До конца
                        ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'поверки', 'калибровки')}
                        осталось менее месяца`;
                    break;
                }
                case EquipmentCardEnums.CalibrationExpiredStatus.soon : {
                    this.popoverMessage = `
                        До конца
                        ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'поверки', 'калибровки')}
                        осталось менее трех месяцев`;
                    break;
                }
            }

            this.message = this.calibration.date_end;

        } else {
            /**
             * Если нет поверки/калибровки, но она обязательна
             */
            if ([VerificationStatus.calibrating, VerificationStatus.ongoing].includes(this.calibrationStatus)) {
                this.cssClass = 'text-danger';
                this.message = `Не ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'поверено', 'откалибровано')}`;
                this.popoverMessage = `Добавьте информацию о
                ${this.calibrationLabelPipe.transform(this.calibrationStatus, 'поверке', 'калибровке')}`;
            }
        }
    }
}
